export default {
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["哈囉 i18n !!"])},
  "errors": {
    "VAS001": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["沒有儲值帳戶"])},
    "VAS002": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["沒有儲值帳戶或商家識別碼"])},
    "VAS003": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["儲值帳戶不存在或已鉒銷"])},
    "VAS004": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["無法取得通知設定"])},
    "VAS005": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["沒有Line Notify識別碼"])}
  }
}